import PropTypes from 'prop-types'
import React from 'react'
import { Tabs } from 'antd'

import './NavigationTab.less'

const NavigationTab = ({
  activeKey,
  className,
  items,
  onTabChange,
  ...restProps
}) => {
  const renderTabBar = (props, DefaultTabBar) => (
    <div className="navigation-tab__container">
      <DefaultTabBar {...props} style={{ border: 0, margin: 0 }} />
    </div>
  )

  return (
    <Tabs
      activeKey={activeKey}
      className={`navigation-tab ${className}`}
      items={items}
      onChange={onTabChange}
      renderTabBar={renderTabBar}
      {...restProps}
    />
  )
}

NavigationTab.propTypes = {
  activeKey: PropTypes.string,
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.node,
      disabled: PropTypes.bool,
      icon: PropTypes.node,
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    })
  ).isRequired,
  onTabChange: PropTypes.func,
}

NavigationTab.defaultProps = {
  activeKey: undefined,
  className: '',
  onTabChange: undefined,
}

export default NavigationTab
